import React from 'react';
import Button from '../../../Components/Button'
import Dialog from '../../../Components/Dialog';
import FollowTips from '../FollowTips';

import './index.scss'

const HasBeenBindDialog = (props) => {
  let { visible, setVisible, status = 2 } = props

  const bindTitleMap = {
    1: '您的身份已被其它音乐人账号绑定，可使用该账号登录使用音乐人功能',
    2: '您的手机号已经和其它音乐人账号绑定，可使用该账号登录使用音乐人功能'
  }
  return (
    <Dialog visible={visible} setVisible={setVisible}>
      <div className="HasBeenBindDialog">
        <header>{bindTitleMap[status]}</header>

        {~~status === 1 && <section className="bindAccount">
          <div className="title">绑定账号</div>
          <div className="info">
            <img src="https://webimg.kgimg.com/6af2808612da044f57e70469d8b279fd.png" />
            <div className="text">
              <p className="name">奔跑的酷小狗</p>
              <p className="id">酷豆ID：989293999393</p>
            </div>
          </div>
        </section>}

        {
          ~~status === 2 && <section className="toPc">
            <p className="first">腾讯音乐人平台</p>
            <p className="second">https://y.tencentmusic.com</p>
          </section>
        }

        <div className="btn">
          {~~status === 1 && <Button text="切换账号登录" />}
          {~~status === 2 && <Button text="好的" />}
        </div>


        <div className="follow">
          <FollowTips />
        </div>
      </div>
    </Dialog>
  );
}

export default HasBeenBindDialog;
